<template>
<div class="surveillance-rea-sink-modal">
  <modal v-model="reaSinkModal"
         :footer="false"
         size="lg"
         :title="`${surveillance.establishment.name} - SPIADI${surveillance.year}`">
    <div v-if="reaSinkModal && surveillance" class="rea-sink-modal">
      <h2>Module <span class="label label-reaSink">Réa-Sink</span></h2>
      <div v-if="status === 0">
        <alert type="warning">
          <h3>
            Établissement inscrit au module<br>
            <small>le {{ date }}</small>
          </h3>
          <p>
            L'utilisateur doit remplir le formulaire de destinataire des
            écouvillons.
          </p>
        </alert>
      </div>
      <div v-else>
        <alert v-if="status === 1" type="info">
          <h3>
            En attente des écouvillons<br>
            <small>le {{ date }}</small>
          </h3>
          <p>
            L'utilisateur a rempli le formulaire de destinataire des
            écouvillons et attend leur envoi.
          </p>
          <p>
            <btn type="warning" @click="reset" :disabled="busy">
              Réinitialiser
            </btn>
            <btn type="success" @click="notifySent" :disabled="busy">
              Écouvillons envoyés
            </btn>
          </p>
        </alert>
        <alert v-else-if="status === 2" type="success">
          <h3>
            Écouvillons envoyés<br>
            <small>le {{ date }}</small>
          </h3>
          <p>
            En attente de confirmation de réception.
          </p>
          <p>
            <btn type="info" @click="notifyReceived" :disabled="busy">
              Écouvillons reçus par l'établissement
            </btn>
          </p>
        </alert>
        <alert v-else-if="status === 3" type="warning">
          <h3>
            Écouvillons reçus par l'établissement<br>
            <small>le {{ date }}</small>
          </h3>
          <p>
            En attente de retour des écouvillons.
          </p>
          <p>
            <btn type="info" @click="notifyReturned" :disabled="busy">
              Écouvillons retournés par l'établissement
            </btn>
          </p>
        </alert>
        <alert v-else-if="status === 4" type="info">
          <h3>
            Écouvillons renvoyés après prélévement<br>
            <small>le {{ date }}</small>
          </h3>
          <p>
            En attende de réception des écouvillons.
          </p>
          <p>
            <btn type="warning" @click="notifyLabo" :disabled="busy">
              Écouvillons reçus au labo
            </btn>
          </p>
        </alert>
        <alert v-else-if="status === 5" type="info">
          <h3>
            Écouvillons reçus au labo<br>
            <small>le {{ date }}</small>
          </h3>
        </alert>
        <div v-if="status >= 5">
          <hr>
          <h3>Analyse des écouvillons</h3>
          <div v-if="editWaterPoints">
            <div class="panel panel-reaSink">
              <div class="panel-heading">
                <div class="panel-title">
                  Déclaration des chambres et points d'eau
                </div>
              </div>
              <div class="panel-body">
                <div v-if="rooms.length === 0">
                  <alert type="warning">
                    Aucune chambre déclarée.
                  </alert>
                </div>

                <div class="row">
                  <div v-for="(r, k) in rooms"
                       class="col-xs-6 col-md-4"
                       :key="`room-${k}`">
                    <div class="panel panel-default">
                      <div class="panel-body">
                        <label class="txt-reaSink">
                          Chambre «{{ r.name }}»
                        </label>
                        <btn class="close pull-right"
                             @click="removeRoom(k)"
                             aria-label="Close">
                          <span aria-hidden="true">&times;
                          </span>
                        </btn>

                        <br/>
                        <span>Points d'eau : </span>
                        <label class="inline-radio">
                          <input type="radio"
                                 v-model="r.waterPoints"
                                 :name="`waterPoints-${k}`"
                                 value="1">
                          1
                        </label>
                        <label class="inline-radio">
                          <input type="radio"
                                 v-model="r.waterPoints"
                                 :name="`waterPoints-${k}`"
                                 value="2">
                          2
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="panel-footer">
                <div class="row">
                  <div class="col-xs-12 col-md-6 form-group">
                    <label>
                      Numéro de chambre
                    </label>
                    <input required
                           v-model="room.value"
                           type="text"
                           class="form-control"
                           placeholder="Numéro de chambre..."/>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-md-6">
                    <btn type="success"
                         block
                         class="form-group"
                         :disabled="room.value === ''"
                         @click="addRoom">Ajouter la chambre</btn>
                  </div>
                </div>
              </div>
            </div>
            <btn type="warning" size="lg" :disabled="rooms.length === 0"
                 @click="saveWaterPoints">
              Enregistrer et générer les numéros court
            </btn>
          </div>
          <div v-else>
            <div v-if="status === 6">
              <alert type="success">
                <p>
                  <strong>
                    L'enquête est terminée pour cette établissement.
                  </strong>
                </p>
                <btn type="default" @click="notifyLabo" :disabled="busy">
                  Revenir à «Écouvillons reçus au labo»
                </btn>
              </alert>
            </div>
            <table class="table table-responsive">
              <thead>
                <tr>
                  <th>Numéro court</th><th>Chambre</th><th>Point d'eau</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(wp, k) in surveillance.modules.reaSink.waterPoints"
                    class="txt-reaSink"
                    :key="`summary-waterpoint-${k}`">
                  <td><strong>{{ wp.id }}</strong></td>
                  <td><strong>{{ wp.room }}</strong></td>
                  <td><strong>{{ wp.name }}</strong></td>
                </tr>
              </tbody>
            </table>
            <div class="button-list" v-if="status === 5">
              <btn type="success" @click="exportWorkbenchPDF">
                Exporter le document de travail
              </btn>
              <btn type="warning" @click="editWaterPoints = true">
                Modifier les points d'eau
              </btn>
              <btn type="primary" @click="notifyEnd">
                Enquête terminée pour cet établissement
              </btn>
            </div>
          </div>
        </div>
        <hr>
        <h3>Destinataire des écouvillons</h3>
        <table class="table table-responsive">
          <tbody>
            <tr>
              <td>Nom</td>
              <td>{{ swab.dest.firstName }} {{ swab.dest.name }}</td>
            </tr>
            <tr>
              <td>Fonction</td>
              <td>{{ swab.dest.role }}</td>
            </tr>
            <tr>
              <td>Établissement</td>
              <td>{{ swab.dest.establishment }}</td>
            </tr>
            <tr>
              <td>Service</td>
              <td>{{ swab.dest.service }}</td>
            </tr>
            <tr>
              <td>Adresse</td>
              <td>{{ swab.dest.address }}</td>
            </tr>
          </tbody>
        </table>
        <hr>
        <h3>Service surveillé</h3>
        <table class="table table-responsive">
          <tbody>
            <tr>
              <td>UF</td>
              <td>{{ uf }}</td>
            </tr>
            <tr>
              <td>Nombre de lits</td>
              <td>{{ swab.beds }}</td>
            </tr>
            <tr>
              <td>Nombre de points d'eau</td>
              <td>{{ swab.points }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </modal>
</div>
</template>

<script>
import units from '@/sui/data/units'
import { confirm } from '@/sui/tools/modal'
import moment from 'moment'
import impl from '@/components/surveillance/impl/reasinkmodal'

export default {
  name: 'surveillance-rea-sink-modal',

  props: {
    surveillance: Object,

    value: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      editWaterPoints: false,
      reaSinkModal: this.value,
      busy: true,
      waterPoints: {
        value: 1
      },

      room: {
        value: '',
        error: ''
      },
      rooms: []
    }
  },

  watch: {
    surveillance: function (s) {
      this.updateFromSurveillance(s)
    },

    reaSinkModal: {
      handler () {
        this.$emit('input', this.reaSinkModal)
      },
      deep: true
    },

    value: function (value) {
      this.reaSinkModal = value
    }
  },

  mounted: function () {
    if (this.surveillance != null) {
      this.updateFromSurveillance(this.surveillance)
    }
  },

  methods: {
    exportWorkbenchPDF: function () {
      impl.exportWorkbenchPDF(this.surveillance)
    },

    updateFromSurveillance: function (s) {
      this.busy = false
      const module = s.modules.reaSink
      if (module == null || module.waterPoints == null ||
          module.waterPoints.length === 0) {
        this.rooms = []
        this.editWaterPoints = true
        return
      }

      const rooms = []
      module.waterPoints.forEach(
        wp => {
          const r = rooms.find(r => wp.room === r.name)
          if (r == null) {
            rooms.push({ name: wp.room, waterPoints: '1' })
          } else {
            r.waterPoints = `${parseInt(r.waterPoints) + 1}`
          }
        }
      )
      this.rooms = rooms
      this.editWaterPoints = rooms.length === 0
    },

    saveWaterPoints: function () {
      const waterPoints = []
      const rs = this.surveillance.modules.reaSink
      const m = rs ? rs.waterPoints : null

      this.rooms.forEach(
        r => {
          const number = parseInt(r.waterPoints) + 1
          for (let j = 1; j !== number; ++j) {
            const wp = {
              room: r.name,
              number: j,
              name: `P${j}`
            }

            if (m != null) {
              for (let i in m) {
                const p = m[i]
                if (p.room === wp.room && p.number === wp.number &&
                    p.name === wp.name) {
                  wp.id = p.id
                }
              }
            }

            waterPoints.push(wp)
          }
        }
      )
      let summary = ''
      waterPoints.forEach(
        wp => {
          const id = wp.id != null ? wp.id : 'à générer'
          summary += `
<div>Chambre «${wp.room}», point d'eau «${wp.name}», id «${id}»</div>`
        }
      )

      confirm(
        this,
        `<h3>Enregistrement des chambres et points d'eau</h3>
<p class="text-justify">
Êtes vous sûr.e de vouloir enregistrer les chambres et les points d'eau de
l'établissement <strong>${this.surveillance.establishment.name}</strong> ?
</p>
<p>${summary}</p>
  `
      ).then(
        () => {
          this.setRoomsAndWaterPoints(waterPoints)
        }
      )
    },

    setRoomsAndWaterPoints: function (waterPoints) {
      const request = {
        id: this.surveillance.id,
        wp: waterPoints
      }

      const vm = this
      vm.busy = true
      this.$store.dispatch('surveillances/updateWaterPoints', request).then(
        r => {
          if (r.data.err != null) {
            vm.busy = false
            vm.$notify(
              {
                type: 'danger',
                title: 'Erreur !',
                duration: 0,
                content: `Une erreur s'est produite pendant l'enregistrement
des chambres et points d'eau : ${r.data.err}.`
              }
            )
          } else {
            vm.$notify(
              {
                type: 'success',
                title: 'Succès !',
                content: `L'enregistrement des chambres et points d'eau
a bien été effectué.`
              }
            )
          }
        }
      ).catch(
        e => {
          const str = e.status === 404 ? `Erreur 404` : e
          vm.busy = false
          vm.$notify(
            {
              type: 'danger',
              title: 'Erreur !',
              duration: 0,
              content: `Une exception s'est produite pendant l'enregistrement
des chambres et points d'eau : ${str}.`
            }
          )
        }
      )
    },

    removeRoom: function (k) {
      const { rooms } = this
      rooms.splice(k, 1)
    },

    addRoom: function () {
      this.rooms.push(
        {
          name: this.room.value,
          waterPoints: this.waterPoints.value
        }
      )
      this.room.value = ''
      this.waterPoints.value = 1
    },

    confirm: function (action, status) {
      confirm(
        this,
        `<h3>Changement de statut
<span class='label-bigger label label-reaSink'>Réa-Sink</span></h3>
<p class="text-justify">
Êtes vous sûr.e de vouloir changer le statut de l'établissement
<strong>${this.surveillance.establishment.name}</strong> en
<strong>«${action}»</strong> ?</p>`
      ).then(() => {
        this.setStatus(status)
      })
    },

    setStatus: function (status) {
      const request = {
        id: this.surveillance.id,
        stat: status
      }
      const vm = this
      vm.busy = true
      this.$store.dispatch('surveillances/updateReaSinkStatus', request).then(
        r => {
          if (r.data.err != null) {
            vm.busy = false
            vm.$notify(
              {
                type: 'danger',
                title: 'Erreur !',
                duration: 0,
                content: `Une erreur s'est produite pendant la mise à jour du
statut Réa-Sink : ${r.data.err}.`
              }
            )
          } else {
            vm.$notify(
              {
                type: 'success',
                title: 'Succès !',
                content: `Le changement de statut Réa-Sink a bien été effectué.`
              }
            )
          }
        }
      ).catch(
        e => {
          const str = e.status === 404 ? `Erreur 404` : e
          vm.busy = false
          vm.$notify(
            {
              type: 'danger',
              title: 'Erreur !',
              duration: 0,
              content: `Une exception s'est produite pendant la mise à jour du
statut Réa-Sink : ${str}.`
            }
          )
        }
      )
    },

    notifySent: function () {
      this.confirm('écouvillons envoyés', 2)
    },

    notifyReceived: function () {
      this.confirm(`écouvillons reçus par l'établissement`, 3)
    },

    notifyReturned: function () {
      this.confirm(`écouvillons renvoyés par l'établissement`, 4)
    },

    notifyLabo: function () {
      this.confirm(`écouvillons reçus au laboratoire`, 5)
    },

    notifyEnd: function () {
      this.confirm(`enquête terminée`, 6)
    },

    reset: function () {
      this.confirm(
        'inscrit (en attente du formulaire de destinataire des écouvillons)',
        0
      )
    }
  },

  computed: {
    swab: function () {
      return this.surveillance.modules.reaSink.swab
    },

    status: function () {
      return this.surveillance.modules.reaSink.status.val
    },

    date: function () {
      const m = moment(this.surveillance.modules.reaSink.status.date)
      return m.format('DD/MM/YYYY à HH:mm')
    },

    uf: function () {
      const uf = this.surveillance.modules.reaSink.uf
      const uy = units[this.surveillance.year]
      return `${uf.name} (${uy.infADI.find(u => u.index === uf.ufType).code})`
    }
  },

  components: {
  }
}
</script>

<style lang="less" scoped>
@import '~variables';
table td:nth-of-type(1) {
  width: 20rem;
  font-weight: bold;
}

.alert {
  .btn:not(:first-child) {
    margin-left: 1rem;
  }
}

.rea-sink-modal {
  & > h1, & > h2, & > h3, & > h4, & > h5 {
    color: @dark-base;
  }

  h1:first-child,
  h2:first-child,
  h3:first-child,
  h4:first-child,
  h5:first-child {
    margin-top: 0rem;
    margin-bottom: 2rem;
  }

  .inline-radio {
    padding-left: 1rem;
  }
}

.alert-success small {
  color: white;
}

.button-list .btn {
  margin-right: 2rem;
}
</style>
